import React from 'react'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

interface Props {
  title: string
  value: string
  subtext?: string
  icon: React.ReactNode
  highlight?: boolean
  tooltip?: string
}

export const ClientMetricCard: React.FC<Props> = ({
  title,
  value,
  subtext,
  icon,
  highlight = false,
  tooltip,
}) => {
  return (
    <div className={`cp-metric-card${highlight ? ' cp-metric-card--highlight' : ''}`}>
      <div className='cp-metric-card__header'>
        <span className='cp-metric-card__title'>
          {title}
          {tooltip && (
            <OverlayTrigger
              placement='top'
              overlay={
                <Tooltip
                  id={`client-metric-${title.replace(/\s+/g, '-').toLowerCase()}`}
                  className='client-portal-tooltip'
                >
                  {tooltip}
                </Tooltip>
              }
            >
              <span className='cp-info-icon' tabIndex={0}>
                i
              </span>
            </OverlayTrigger>
          )}
        </span>
        <div className='cp-metric-card__icon'>{icon}</div>
      </div>
      <div className='cp-metric-card__value'>{value}</div>
      {subtext && <div className='cp-metric-card__subtext'>{subtext}</div>}
    </div>
  )
}
